/**
 * Brand Configuration
 * Centralized configuration for brand identity and styling
 * All values are loaded from environment variables for easy customization
 */

const brandConfig = {
  // Brand Name Components
  name: process.env.REACT_APP_NAME || 'LotesPro',
  namePrefix: process.env.REACT_APP_NAME_PREFIX || 'Lotes',
  nameSuffix: process.env.REACT_APP_NAME_SUFFIX || 'Pro.com',
  domain: process.env.REACT_APP_DOMAIN || 'lotespro.com',
  clientCountryUrl: process.env.REACT_APP_CLIENT_COUNTRY_URL || 'https://proyectos.lotespro.com',
  clientHomeUrl: process.env.REACT_APP_CLIENT_HOME_URL || 'https://lotespro.com',
  
  // Brand Colors
  primaryColor: process.env.REACT_APP_BRAND_COLOR || '#E8751A',
  secondaryColor: '#FFBF00',

  // Brand Messaging
  slogan: process.env.REACT_APP_BRAND_SLOGAN || 'Plataforma Inmobiliaria',

  // API & Service URLs
  apiUrl: process.env.REACT_APP_API_URL || 'http://api.lotespro.com/api/v1',
  dashboardUrl: process.env.REACT_APP_DASHBOARD_URL || 'https://dashboard.lotespro.com',
  tilerUrl: process.env.REACT_APP_TILER_URL || 'https://tiles.lotespro.com',
  mapStyleUrl: process.env.REACT_APP_MAP_STYLE_URL || 'https://styles.lotespro.com/styles_country.json',
  spritesUrl: process.env.REACT_APP_SPRITES_URL || 'https://styles.lotespro.com/sprites',
  baseUrl: process.env.REACT_APP_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '/'),
  projectDemoUrl: process.env.REACT_APP_PROJECT_DEMO || '/proyectos/residencial-santa-clara',

  // Martin Vector Tiles Routes (direct routes - Martin serves each layer separately)
  tilerTiles: {
    lotesAreas: '/lotes_areas/{z}/{x}/{y}',
    lotesCentroid: '/lotes_centroid/{z}/{x}/{y}',
    lotesproMarkers: '/lotespro_markers/{z}/{x}/{y}',
    lotesproAreas: '/lotespro_areas/{z}/{x}/{y}',
    lotesproAreasCentroid: '/lotespro_areas_centroid/{z}/{x}/{y}',
    lotesproLines: '/lotespro_lines/{z}/{x}/{y}',
  },

  // API Keys & Tokens
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1IjoicnViZW4iLCJhIjoiY21nMW44c3I2MHE1YTJscHV2Y253YXV1aiJ9.dgDZebxjM5YP5lEKDn3woQ',
  thunderforestApiKey: process.env.REACT_APP_THUNDERFOREST_API_KEY || '1865257509e140189a45b040ccfbbca3',
  gaId: process.env.REACT_APP_GA_ID || '',
  
  // Contact & Support
  emailContact: process.env.REACT_APP_EMAIL_CONTACT || 'info@cloud4geo.com',

  // Helper methods
  getFullName: () => {
    return `${brandConfig.namePrefix}${brandConfig.nameSuffix.replace('.com', '')}.com`;
  },

  getPrimaryGradient: () => {
    return `linear-gradient(135deg, ${brandConfig.primaryColor} 0%, ${brandConfig.secondaryColor} 100%)`;
  },

  getLogoAlt: () => {
    return `${brandConfig.domain} Logo`;
  }
};

/**
 * Construye la URL completa de un tile con filtro opcional de project_id.
 * Martin pasa los query params a las funciones SQL como JSON.
 */
export function getTileUrl(tilePath, projectId, extraParams) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  if (extraParams) {
    Object.entries(extraParams).forEach(([key, value]) => {
      params.set(key, String(value));
    });
  }
  const qs = params.toString();
  return brandConfig.tilerUrl + tilePath + (qs ? `?${qs}` : '');
}

export default brandConfig;
